import humps from "humps";

const normalizeToolbar = raw => humps.camelizeKeys(raw);

export default normalizeToolbar;
